import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { ROUTE_PATHS } from 'common/routePaths'

import NotFound from 'errorPages/NotFound'

import CompanyDetails from './companyDetails'
import CsiSearch from './searchCustomers'

const Csi: React.FC = () => {
  return (
    <Switch>
      <Route path={ROUTE_PATHS.CSI_SEARCH} exact component={CsiSearch} />
      <Route path={`${ROUTE_PATHS.CSI_COMPANY_DETAILS}/:companyId`} component={CompanyDetails} />
      <Route component={NotFound} />
    </Switch>
  )
}

export default Csi
